
import { supabase } from '@/integrations/supabase/client';

// Revoke an invitation
export const revokeInvitation = async (invitationId: string): Promise<boolean> => {
  try {
    // First, get the email of the invited user
    const { data: invitation, error: fetchError } = await supabase
      .from('employee_invitations')
      .select('email')
      .eq('id', invitationId)
      .single();
      
    if (fetchError) {
      console.error("Error fetching invitation:", fetchError);
      return false;
    }
    
    // Delete the invitation record
    const { error: deleteError } = await supabase
      .from('employee_invitations')
      .delete()
      .eq('id', invitationId);
    
    if (deleteError) {
      console.error("Error deleting invitation:", deleteError);
      return false;
    }
    
    return true;
  } catch (error) {
    console.error("Error in revoke invitation process:", error);
    return false;
  }
};
